import { z } from 'zod';
import { elementSchema, ideationBriefSchema, words } from '../brief/briefResult.js';

export const storyboardVersionSchema = z.object({
  name: z.string(),
  strategy: z.string(),
  // Display copy for `strategy`; empty until the service ships it, and then hidden.
  strategy_label: z.string().default(''),
  display_chips: words,
  rationale: z.string(),
  creative_premise: z.string(),
  departure_from_references: z.string(),
  reference_ids: words,
  cta: z.string(),
  creative_direction: z.object({
    music: z.string(),
    hero_product: z.string(),
    tone: z.string(),
    visual_style: words,
    palette: words,
    element_ids: words,
  }),
  scenes: z.array(
    z.object({
      shot_label: z.string(),
      framing: z.string(),
      camera_style: z.string(),
      objective: z.string(),
      start_seconds: z.number().nullable().default(null),
      end_seconds: z.number().nullable().default(null),
      visual: z.string(),
      on_screen_text: z.string().default(''),
      voiceover: z.string().default(''),
      audio: z.string().default(''),
      cta: z.string().default(''),
      element_ids: words,
    }),
  ),
});
export const storyboardResultSchema = z.object({
  storyboard: z.object({
    name: z.string(),
    body: z.string(),
    format: z.string(),
    duration_seconds: z.number().nullable(),
    aspect_ratio: z.string(),
    primary_kpi: z.string(),
    primary_kpi_label: z.string().optional(),
    source_brief: ideationBriefSchema.optional(),
    context: z.string(),
    production_instructions: z.string(),
    elements: z.record(z.string(), elementSchema),
    references: z.array(
      z.object({
        id: z.string(),
        selection_reason: z.string(),
        observed: z.boolean(),
        structure: z.string(),
        creative: z.object({ creative_id: z.string() }),
      }),
    ),
    warnings: words,
  }),
  versions: z.array(storyboardVersionSchema),
});

export type StoryboardResult = z.infer<typeof storyboardResultSchema>;
export type StoryboardVersion = z.infer<typeof storyboardVersionSchema>;
export type Scene = StoryboardVersion['scenes'][number];
export type StoryboardElements = StoryboardResult['storyboard']['elements'];
